const pxStudentRegistrants = {
  path: 'invoice/:classIdAndUserLoginIdBuf',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/invoice'], resolve)
}
export default pxStudentRegistrants



// WEBPACK FOOTER //
// ./src/router/pages/student_user/invioce/index.js